<template>
    <Title title = 'paymentsummarypage.title'/>

    <img v-if="loading" src='@/assets/loading-buffering.gif' class='h-20 w-20 mx-auto mt-10' />

    <div v-if="!loading" class='w-full px-2 sm:w-1/2 mx-auto mt-10 pb-20'>
        <div style="border: 1px solid black;">
            <div>
                <h1 style="font-weight: bold; background-color: gainsboro;">Maklumat Pembayaran</h1>
            </div>
            <div v-if="fpxPaymentStatus" class="">
                <table>
                    <tr>
                        <td>Status Transaksi: </td>
                        <td v-show="fpxPayment.status == 'Y'">Berjaya</td>
                        <td v-show="fpxPayment.status == 'N'">Tidak Berjaya</td>
                    </tr>
                    <tr>
                        <td>Tarikh Transaksi: </td>
                        <td>{{ transactionDate }}</td>
                    </tr>
                    <tr>
                        <td>ID Transaksi FPX: </td>
                        <td>{{ fpxPayment.fpxtxnid }}</td>
                    </tr>
                    <tr>
                        <td>No Rujukan Transaksi: </td>
                        <td>{{ fpxPayment.refno }}</td>
                    </tr>
                    <tr>
                        <td>No Geran: </td>
                        <td>{{ fpxPayment.titleno }}</td>
                    </tr>
                    <tr>
                        <td>Jumlah Pembayaran: </td>
                        <td>RM {{ $n(fpxPayment.amt, 'decimal') }}</td>
                    </tr>
                    <tr>
                        <td>Nama Pembayar: </td>
                        <td>{{ fpxPayment.payername }}</td>
                    </tr>
                    <tr>
                        <td>Bank: </td>
                        <td>{{ fpxPayment.bankcode }}</td>
                    </tr>
                </table>
            </div>
            <div v-if="!fpxPaymentStatus" class="grid grid-cols-3 mt-5 mb-5 px-2 text-sm sm:text-base">
                <div class='col-span-3'>Status Transaksi: Tidak Berjaya</div>
            </div>
        </div>
    </div>
</template>

<script>
import Title from '@/components/Title'
import axios from 'axios'
import config from '@/config'

export default {
    name:"PaymentSummary",
    data: () => {
        return {
            refno: "",
            loading: false,
            fpxPayment: [],
            fpxPaymentStatus: false,
            transactionDate: ""
        }
    },
    mounted: function () {

        this.refno = this.$route.query.refno;

        this.loading = true;

        axios.get(config.CHECKFPX_URL + "/" + this.refno)
        .then(res => {
            if(res.data.status){
                this.fpxPaymentStatus = res.data.status;
                this.fpxPayment = res.data.fpxPayment;
                this.transactionDate = res.data.transactionDate;
            }

            this.loading = false;
        })
    },
    components:{
        Title
    }
}

function closeWindow(){
    alert('The window will be closed');
    window.close();
}

</script>